import { Box } from '@mui/material'

import { tokens } from '@/theme'

/**
 * The Fronted mark, inline.
 *
 * The same three rectangles as `public/favicon.svg` and `scripts/make_icons.py`
 * — a stem and two arms — so the tab, the home screen and the top bar are one
 * shape rather than three that drifted.
 *
 * Inline rather than an <img>: it inherits colour, it costs no request on a
 * page whose whole design is about not costing a request, and it stays sharp
 * without anybody choosing a size to export at.
 *
 * Decorative. The wordmark beside it already says "Fronted", so announcing it
 * again reads the name twice to a screen reader.
 */
export function Mark({ size = 20 }: { size?: number }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      sx={{ width: size, height: size, flexShrink: 0, display: 'block' }}
    >
      <rect width="32" height="32" rx="7" fill={tokens.accent} />
      <path d="M10 7h12v4h-8v4h7v4h-7v6h-4z" fill={tokens.accentFg} />
    </Box>
  )
}
